import React from 'react';
import PropTypes from 'prop-types';

import iconMinus from '../../../../assets/svg/icon-minus.svg';
import iconPlus from '../../../../assets/svg/icon-plus.svg';

const QuantitySelector = ({item, maxQty, updateLineItems, setDisplayQtyLimitMessage}) => {
  const handleQuantityInputBlur = (event) => {
    const inputValue = Number(event.target.value);

    if (item.quantity === inputValue) return;

    let newQuantity = null;

    if (maxQty && inputValue > maxQty) {
      newQuantity = maxQty;
      setDisplayQtyLimitMessage(true);
    } else {
      newQuantity = inputValue;
      setDisplayQtyLimitMessage(false);
    }

    if (!newQuantity) return;

    updateLineItems({[item.key]: newQuantity});
  };

  const handleQtyDecreaseBtnClick = () => {
    setDisplayQtyLimitMessage(false);
    updateLineItems({[item.key]: item.quantity - 1});
  };

  const handleQtyIncreaseBtnClick = () => {
    if (maxQty && item.quantity >= maxQty) {
      setDisplayQtyLimitMessage(true);
      return;
    }

    updateLineItems({[item.key]: item.quantity + 1});
  };

  return (
    <>
      <div className="quantity-selector">
        <button
          onClick={handleQtyDecreaseBtnClick}
          className="btn-none"
          type="button"
          aria-label={window.theme.strings.accessibility.decrementQuantity}
          dangerouslySetInnerHTML={{__html: iconMinus}}
        />
        <input
          id={`cart-qty_${item.key}`}
          type="number"
          name="quantity"
          min="1"
          max={maxQty}
          aria-label={window.theme.strings.itemQuantity}
          value={item.quantity}
          autoComplete="off"
          onBlur={handleQuantityInputBlur}
        />
        <button
          onClick={handleQtyIncreaseBtnClick}
          className="btn-none"
          type="button"
          aria-label={window.theme.strings.accessibility.incrementQuantity}
          dangerouslySetInnerHTML={{__html: iconPlus}}
        />
      </div>
    </>
  );
};

QuantitySelector.propTypes = {
  item: PropTypes.object,
  maxQty: PropTypes.number,
  updateLineItems: PropTypes.func,
  setDisplayQtyLimitMessage: PropTypes.func,
};

export default QuantitySelector;
